import ConsumerRefService from "@api/consumer/consumerRefService";
import {GoalConditionType, IGoalCondition, IGoalDonateCondition} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {GoalConditionFormValues} from "../forms/conditionBaseInfoBlock";
import GoalConditionForm from "./goalConditionForm";

interface EditConditionFormProps {
    cond: IGoalCondition;
}

const EditConditionForm: FC<EditConditionFormProps> = ({cond}) => {

    const initialValues: GoalConditionFormValues = {
        name: cond.name,
        isActive: cond.isActive,
        type: cond.type,
        donateValue: cond.type === GoalConditionType.Donate ? (cond as IGoalDonateCondition).donateValue : undefined
    }

    const onSubmit = useCallback(async (values: GoalConditionFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.patchCondition(cond.goalId, {
            id: cond.id,
            name: values.name,
            isActive: values.isActive,
            donateValue: values.donateValue
        });

        if (result.success) {
            toastr.success("Изменение условия", "Условие достижения успешно обновлено");
        }
        else {
            if (result.errorCode === 'GoalNotFound') {
                toastr.error('Изменение условия', 'Достижение не найдено');
            }
            else if (result.errorCode === 'ConditionNotFound') {
                toastr.error('Изменение условия', 'Условие не найдено');
            }
            else if (result.errorCode === 'InvalidRequest') {
                toastr.error('Изменение условия', 'Некорректные параметры условия');
            }
            else {
                toastr.error('Изменение условия', 'Неизвестная ошибка');
            }
        }

    }, [cond.goalId, cond.id]);

    return (
        <GoalConditionForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={true}
            title="Редактирование условия"
            cancelUrl={`/consumer/goals/${cond.goalId}/conditions/`}
        />
    )
}

export default EditConditionForm;
